export const PROJECT_CONSTANTS = {
  MESSAGES: {
    ADDED: "Projects Created Successfully.",
    UPDATED: "Projects Updated Successfully.",
    TABLE_UPDATE: "Project Table Updated.",
    STATUS_UPDATED: "Project Status Updated Successfully.",
  },
  ASSIGN_TOOLS_CONSTANTS: {
    CONTENT_TEXT: {
      ONSITE: "On Site",
      AWAITING: "Awaiting",
      RETURN: "Return",
      ASSIGN_TOOLS: "Assign Tools",
      ASSIGN_TO_PROJECT: "Assign to Project",
      VIEW_LOGS: "View Logs",
      TOOLS: "Tools",
      LOG_HISTORY: "Log History",
      ACTIVITY: "Activity",
      SEND: "Send",
      WRITE_COMMENT: "Write Comment...",
      DELETE_CONFIRMATION_DESC:
        "If you delete this you cannot undo this action!",
      SENT_TO_SITE_CONFIRMATION:
        "You want to send this products to the site? This action cannot be undone!",
      SENT_TO_SITE_CONFIRMATION_TITLE: "Are you Sure?",
      CONFIRMATION_BTN: "Yes, Send to Site",
    },
    EMPTY_MESSAGE: {
      NO_LOG_DATA: "No log data available",
      NO_COMMENTS_FOUND: "comments",
      NO_TOOLS_AVAILABLE: "No tools available to assign",
      NO_AWAITING_TOOLS: "Awaiting tools",
    },
    TOAST_MESSAGE: {
      PRODUCT_ASSIGNED: "Product assigned to project successfully",
      TOOLS_UPDATED: "Tools updated successfully",
      COMMENT_ADDED: "Comment added successfully",
      NO_PRODUCTS_ASSIGNED:
        "There are no assigned products, so you can't send them to the site.",
      PRODUCT_REMOVED_SUCCESSFULLY: "Product removed successfully",
      SENT_TO_SITE_SUCCESSFULLY: "Products sent to site successfully",
    },
  },
};

export enum ProjectConstantLocalKeys {
  PROJECT_NAME = "projectSheetName",
  CLIENT_NAME = "projectSheetCustomer",
}
